export default [
    {
        path: 'atendimento-medico',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-atendimento-medico' */
            '@/views/pronto-atendimento/atendimento-medico/Index'
        ),
        redirect: 'atendimento-medico/index',
        children: [
            {
                name: 'pronto-atendimento-atendimento-medico-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-atendimento-medico' */
                    '@/views/pronto-atendimento/atendimento-medico/List.vue'),
            },
            {
                name: 'pronto-atendimento-atendimento-medico-create',
                path: 'create/:id/:plantaoId',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-atendimento-medico' */
                    '@/views/pronto-atendimento/atendimento-medico/Form.vue'
                ),
            },
        ]
    }
]